import { SVGAttributes } from "react";

export const BrandingIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" }
) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2a1 1 0 00-1 1v10a1 1 0 001 1h5a1 1 0 001-1V3a1 1 0 00-1-1H4zm1 10V4h3v8H5z"
        fill="currentColor"
      />
      <path
        d="M10.684 4.949a1 1 0 01.632-1.898l3 1a1 1 0 01.598 1.355l-4 9a1 1 0 01-1.361.488l-2-1a1 1 0 11.894-1.788l1.064.532L12.64 5.6l-1.955-.651z"
        fill="currentColor"
      />
      <path
        d="M4 8.5v-1h5v1H4zM9.842 8.474l.316-.948 3 1-.316.948-3-1z"
        fill="currentColor"
      />
    </svg>
  );
};
BrandingIcon.displayName = "BrandingIcon";
